import { Injectable } from '@angular/core';
import { ToastController, LoadingController, AlertController } from '@ionic/angular';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { TimezoneService } from './timezone.service';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  public loadingWindow: any;

  constructor(
      public loadingController: LoadingController,
      public alertController: AlertController,
      public toastrService: ToastrService,
      public timezoneService: TimezoneService
  ) { }

  async presentLoadingWindow(msg: string, id?: string) {
    this.loadingWindow = await this.loadingController.create({
      message: msg,
      id: id
    });
    return this.loadingWindow.present();
  }

  async dismissLoadingWindowById(id: string){
    await this.loadingController.dismiss(null, null, id);
  }

  async presentAlert(title: string, message: string, btnText: string = "OK") {
    return new Promise<void>(async (resolve) => {
      const alert = await this.alertController.create({
        header: title,
        message: message,
        cssClass: 'leave-alert',
        buttons: [{
          text: btnText,
          cssClass: 'leave-button',
          handler: () => {
            resolve();
          }
        }
        ]
      });
      await alert.present();
    });
  }

  async presentToast(message: string, type: string = "info", title: string = "", position: string = "bottom-right") {
    return new Promise<void>(async (resolve) => {
      switch(type){
        case 'info': {
          this.toastrService.info(message, title, {
            timeOut: 4000,
            positionClass: 'toast-' + position,
            closeButton: true,
            toastClass: "ngx-toastr toast-content"
          });
          break;
        }
        case 'success': {
          this.toastrService.success(message, title, {
            timeOut: 4000,
            positionClass: 'toast-' + position,
            closeButton: true,
            toastClass: "ngx-toastr toast-content"
          });
          break;
        }
        case 'warning': {
          this.toastrService.warning(message, title, {
            timeOut: 4000,
            positionClass: 'toast-' + position,
            closeButton: true,
            toastClass: "ngx-toastr toast-content"
          });
          break;
        }
        case 'error': {
          this.toastrService.error(message, title, {
            timeOut: 4000,
            positionClass: 'toast-' + position,
            closeButton: true,
            toastClass: "ngx-toastr toast-content"
          });
          break;
        }
        default: {
          break;
        }
      }

      if(document.querySelector('#Smallchat') && document.querySelector("#Smallchat").style.display != "none"){
        if(document.querySelector('.toast-container.toast-bottom-right')){
          document.querySelector('.toast-container.toast-bottom-right').style.bottom = "40px";
        }
      }else{
        if(document.querySelector('.toast-container.toast-bottom-right')){
          document.querySelector('.toast-container.toast-bottom-right').style.bottom = "12px";
        }
      }

      resolve();
    });
  }

  getDateString(date: Date, dateFormat: string = 'EU', timezone: string = '') 
  {
    var dateTime = this.timezoneService.getTimestampInTimezone(date, timezone);
    return this.timezoneService.getFormattedDateTime(dateTime, dateFormat);
  }
}
